module.exports = "img/flags/CM.b53a3f5.png";